import { useContext } from 'react';
import { GlobalContext, GlobalContextProps } from '../context/global';

export const useGlobal = (): GlobalContextProps => useContext(GlobalContext);
